// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","imageWrapper":"Header_imageWrapper__iUy95","logo":"Header_logo__UsziS","innerHeader":"Header_innerHeader__V+R4j","button":"Header_button__eZN2O"};